import { ILogger } from '@sparkware/uc-sdk-core';
import { LoggerProvider } from '../../logger/logger-provider';
import { Container, Service } from 'typedi';
import { SessionSimpleStoreService } from '../../storage/implementations/simple-store';
import { StorageItemEnum } from '../../../models/enums/storage-enums';

@Service()
export class AttributionPersistence {
    private readonly _logger: ILogger;
    private readonly _sessionSimpleStoreService: SessionSimpleStoreService;

    constructor() {
        this._logger = Container.get(LoggerProvider).getLogger('AttributionPersistence');
        this._sessionSimpleStoreService = Container.get(SessionSimpleStoreService);
    }

    public getBusinessCorrelationId(): string | undefined {
        try {
            const userJourneyData = this._sessionSimpleStoreService.get(
                StorageItemEnum.UserJourneyData,
            );

            return userJourneyData ?? undefined;
        } catch (error) {
            this._logger.error('AttributionPersistence', 'Error fetching business correlation id', {
                error,
            });
            return undefined;
        }
    }

    public updateBusinessCorrelationId(businessCorrelationId: string): void {
        try {
            this._sessionSimpleStoreService.set(
                StorageItemEnum.UserJourneyData,
                businessCorrelationId,
            );
            this._logger.debug('AttributionPersistence', 'Updated business correlation id', {
                businessCorrelationId,
            });
        } catch (error) {
            this._logger.error('AttributionPersistence', 'Error updating business correlation id', {
                error,
            });
        }
    }

    public clearBusinessCorrelationId(businessCorrelationId?: string): void {
        try {
            if (businessCorrelationId) {
                const currentBusinessCorrelationId = this._sessionSimpleStoreService.get(
                    StorageItemEnum.UserJourneyData,
                );
                if (businessCorrelationId === currentBusinessCorrelationId) {
                    this._sessionSimpleStoreService.remove(StorageItemEnum.UserJourneyData);
                    this._logger.debug(
                        'AttributionPersistence',
                        'Cleared business correlation id',
                        {
                            businessCorrelationId,
                        },
                    );
                }
            } else {
                this._sessionSimpleStoreService.remove(StorageItemEnum.UserJourneyData);
                this._logger.debug('AttributionPersistence', 'Cleared business correlation id', {
                    businessCorrelationId,
                });
            }
        } catch (error) {
            this._logger.error('AttributionPersistence', 'Error clearing business correlation id', {
                error,
            });
        }
    }
}
